module.exports = __webpack_public_path__ + "e929e161b1f76d9c970360d1b4103b0b.svg";